import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import sessionHandling from "services/utils/notificationUtils";
import { showToast } from "services/utils/Status";

export const useFetch = (url) => {
  const token = useSelector((state) => state.tokenReducer.token);
  const requestKey = JSON.stringify([url, token]);
  const [result, setResult] = useState([]);
  const [resultKey, setResultKey] = useState("");
  const [load, setLoad] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (url) {
      setLoad(true);
    }
  }, [url, token]);

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "content-type": "application/json",
            Authorization: `token ${token}`,
          },
        });

        if (cancelled) return;
        if (response.status === 409) {
          sessionHandling(token);
          return;
        }

        let res = null;
        try {
          res = await response.json();
        } catch {
          res = null;
        }
        if (cancelled) return;

        if (response.ok) {
          setResult(Array.isArray(res) ? res : (res?.results ?? res));
          setResultKey(requestKey);
          setLoading(false);
          return;
        }

        // Surface the backend's actual message (e.g. a permission-denied
        // reason) instead of a blanket "Something went wrong" -- same
        // convention as customGetAPI/customDeleteAPI in CustomAPI.js.
        throw new Error(
          res?.error ||
            res?.errors?.[0]?.message ||
            res?.detail ||
            res?.message ||
            "Something went wrong. Please try again.",
        );
      } catch (_error) {
        if (cancelled) return;
        console.error('[Usefetch] operation failed:', _error);
        showToast(
          "error",
          _error?.message || "Something went wrong. Please try again.",
        );
        setResult([]);
        setResultKey(requestKey);
        setLoading(false);
      } finally {
        if (!cancelled) setLoad(false);
      }
    };
    if (token && url && load) {
      fetchData();
    }
    return () => { cancelled = true; };
  }, [load, token, url, requestKey]);

  return {
    result: resultKey === requestKey ? result : [],
    setLoad,
    loading,
  };
};
